/* global IntersectionObserver */
import { register } from '../../../Javascript/Utils'

const tabs = el => {
  const componentPrefix = el.dataset.componentprefix
  const navigation = el.querySelector('ul')
  const arrowLeft = el.querySelector(`.${componentPrefix}-prev`)
  const arrowRight = el.querySelector(`.${componentPrefix}-next`)
  const firstItem = navigation.querySelector('li:first-child')
  const lastItem = navigation.querySelector('li:last-child')
  const links = navigation.querySelectorAll('.tab-link')
  let noHashTab = true
  let currentHash = window.location.hash

  const updateArrow = (entry, arrow) => {
    const intersectionClass = arrow === arrowLeft ? `${componentPrefix}intersecting--prev` : `${componentPrefix}intersecting--next`
    navigation.classList.toggle(intersectionClass, !entry.isIntersecting)
    arrow.classList.toggle(`${componentPrefix}-hidden`, entry.isIntersecting)
  }

  const observerLeft = new IntersectionObserver(
    (entries) => updateArrow(entries[0], arrowLeft),
    { root: navigation, threshold: 1 }
  )
  const observerRight = new IntersectionObserver(
    (entries) => updateArrow(entries[0], arrowRight),
    { root: navigation, threshold: 1 }
  )

  observerLeft.observe(firstItem)
  observerRight.observe(lastItem)

  arrowLeft.addEventListener('click', () => {
    navigation.scrollBy({ left: -navigation.clientWidth * 0.6, behavior: 'smooth' })
  })

  arrowRight.addEventListener('click', () => {
    navigation.scrollBy({ left: navigation.clientWidth * 0.6, behavior: 'smooth' })
  })

  const setActive = () => {
    currentHash = window.location.hash
    noHashTab = true

    links.forEach(link => {
      const active = link.getAttribute('href') === currentHash
      toggleTab(link, active)
    })

    if (noHashTab) {
      toggleTab(links[0], true)
    }
  }

  const toggleTab = (link, active) => {
    const tabContent = el.querySelector(link.getAttribute('href') + '-content')
    link.classList.toggle('active', active)
    tabContent.classList.toggle('active', active)

    if (active) {
      link.setAttribute('aria-current', 'page')
      noHashTab = false
    } else {
      link.removeAttribute('aria-current')
    }
  }

  if (links.length > 0) {
    window.addEventListener('hashchange', setActive)
    setActive()
  }

  navigation.querySelector('.active').scrollIntoView({ behavior: 'instant', block: 'center', inline: 'center' })
}

register('tabs', tabs)
